export type FileIconConfig = {
  icon: string
  color: string
}

const FILE_ICONS = {
  image: { icon: 'bi bi-file-earmark-image', color: '#6B70F2' },
  pdf: { icon: 'bi bi-filetype-pdf', color: '#F1502F' },
  xls: { icon: 'bi bi-filetype-xls', color: '#2E8552' },
  xlsx: { icon: 'bi bi-filetype-xlsx', color: '#2E8552' },
  csv: { icon: 'bi bi-filetype-csv', color: '#FF9E40' },
  doc: { icon: 'bi bi-filetype-doc', color: '#236BB1' },
  docx: { icon: 'bi bi-filetype-docx', color: '#236BB1' },
  ppt: { icon: 'bi bi-filetype-ppt', color: '#B93D24' },
  pptx: { icon: 'bi bi-filetype-pptx', color: '#B93D24' },
  txt: { icon: 'bi bi-filetype-txt', color: '#3297ff' },
  default: { icon: 'bi bi-file-earmark-check', color: '#6C6DF2' },
}

export const getFileIconByFileName = (fileName: string): FileIconConfig => {
  if (!fileName) return FILE_ICONS.default

  const formattedfileName = fileName.toLowerCase()

  if (
    formattedfileName.endsWith('.jpg') ||
    formattedfileName.endsWith('.jpeg') ||
    formattedfileName.endsWith('.gif') ||
    formattedfileName.endsWith('.png')
  ) {
    return FILE_ICONS.image
  }
  if (formattedfileName.endsWith('.pdf')) return FILE_ICONS.pdf
  if (formattedfileName.endsWith('.xls')) return FILE_ICONS.xls
  if (formattedfileName.endsWith('.xlsx')) return FILE_ICONS.xlsx
  if (formattedfileName.endsWith('.csv')) return FILE_ICONS.csv
  if (formattedfileName.endsWith('.doc')) return FILE_ICONS.doc
  if (formattedfileName.endsWith('.docx')) return FILE_ICONS.docx
  if (formattedfileName.endsWith('.ppt')) return FILE_ICONS.ppt
  if (formattedfileName.endsWith('.pptx')) return FILE_ICONS.pptx
  if (formattedfileName.endsWith('.txt')) return FILE_ICONS.txt

  return FILE_ICONS.default
}
